import { useMemo } from "react";
import { useImmer } from "use-immer";

import { IgTextField } from "@intelligems/ig-theme";
import { ExpressionNodeQueryType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { useGetShopDomain } from "@src/api/shops/get-domain";

import { isUrlValid } from "../../utils/validators";

interface UrlValueProps {
  value: string;
  onChange: (
    value: any,
    changeKey: Exclude<keyof ExpressionNodeQueryType, "type">
  ) => void;
}

export const UrlValue = ({ value, onChange }: UrlValueProps) => {
  const domain = useGetShopDomain();
  const [error, setError] = useImmer<string | null>(null);
  const errorMessage = useMemo(() => {
    if (!error) {
      return "";
    } else {
      return error;
    }
  }, [error, value]);
  return (
    <Grid item sx={{ width: "50%" }}>
      <IgTextField
        error={error !== null}
        fullWidth={true}
        label={errorMessage}
        placeholder={
          domain.data
            ? `subdomain.${new URL(domain.data).host}`
            : "subdomain.site.com"
        }
        value={value || ""}
        onChange={(e) => {
          onChange(e.target.value ?? "", "value");
          setError((draft) => {
            draft = isUrlValid(
              e.target.value || "",
              domain.data || ""
            ).errorMessage;
            return draft;
          });
        }}
      />
    </Grid>
  );
};
